module.exports = __webpack_public_path__ + "static/img/c28.1daa073.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c28.png
// module id = 109
// module chunks = 10